export default __webpack_public_path__ + "static/media/image-1.da3733bc.webp";